/* Swap a chosen product while keeping the storefront header and cart mounted. */
(() => {
  if (window.asmProductChoiceNavigation) return;
  window.asmProductChoiceNavigation = true;
  const touchLayout = matchMedia('(max-width:989px), (max-width:1366px) and (pointer:coarse)');
  const loadedScripts = new Set();
  const buttonStates = new WeakMap();
  let activeRequest;

  async function loadProduct(url, pushHistory, direction = 0) {
    const main = document.querySelector('main#MainContent');
    const product = main?.querySelector('product-info[data-product-handle]');
    if (!main || !product || typeof HTMLUpdateUtility === 'undefined') return;
    activeRequest?.abort();
    const request = new AbortController();
    activeRequest = request;
    const scrollPosition = window.scrollY;
    product.abortController?.abort();
    const buttons = [...product.querySelectorAll('product-form [type="submit"], variant-selects input, variant-selects select, .asm-premium-unit button, quantity-input button, quantity-input input')];
    const previousDisabled = buttons.map(button => {
      if (!buttonStates.has(button)) buttonStates.set(button, button.disabled);
      return buttonStates.get(button);
    });
    buttons.forEach(button => { button.disabled = true; });
    product.setAttribute('aria-busy', 'true');
    product.classList.add('asm-product-choice-loading');
    let feedback = product.querySelector('.asm-choice-feedback');
    if (!feedback) {
      feedback = document.createElement('p');
      feedback.className = 'asm-choice-feedback';
      feedback.setAttribute('role', 'status');
      feedback.setAttribute('aria-live', 'polite');
      (product.querySelector('.asm-product-carousel') || product.querySelector('.asm-page-choice__popover'))?.append(feedback);
    }
    feedback.textContent = 'Məhsul yüklənir…';
    try {
      const response = await fetch(url, {
        signal: request.signal,
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) throw new Error('Product request failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (request !== activeRequest) return;
      const incomingMain = html.querySelector('main#MainContent');
      if (!incomingMain?.querySelector('product-info[data-product-handle]')) {
        throw new Error('Product content missing');
      }

      // Already registered components must not register their scripts again.
      document.querySelectorAll('script[src]').forEach(script => loadedScripts.add(script.src));
      incomingMain.querySelectorAll('script[src]').forEach(script => {
        const source = new URL(script.getAttribute('src'), url).href;
        if (loadedScripts.has(source)) script.remove();
        else loadedScripts.add(source);
      });
      incomingMain.querySelectorAll('.scroll-trigger').forEach(element => {
        element.classList.add('scroll-trigger--cancel');
      });
      main.querySelectorAll('product-info').forEach(node => node.asmPageGroups?.destroy());
      HTMLUpdateUtility.setInnerHTML(main, incomingMain.innerHTML);
      document.title = html.title || document.title;
      for (const selector of ['link[rel="canonical"]', 'meta[name="description"]', 'meta[property="og:title"]', 'meta[property="og:url"]', 'meta[property="og:image"]']) {
        const current = document.head.querySelector(selector);
        const incoming = html.head.querySelector(selector);
        if (current && incoming) {
          const attribute = current.tagName === 'LINK' ? 'href' : 'content';
          current.setAttribute(attribute, incoming.getAttribute(attribute));
        }
      }
      if (pushHistory) history.pushState({ ...history.state, asmProductChoice: true }, '', url);
      main.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      window.Shopify?.PaymentButton?.init();
      window.ProductModel?.loadShopifyXR();
      window.scrollTo(0, scrollPosition);
      const card = main.querySelector('.asm-product-detail-card');
      if (direction && card && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
        card.animate([
          { opacity: .35, transform: `translateX(${direction * 28}px)` },
          { opacity: 1, transform: 'translateX(0)' },
        ], { duration: 300, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
      const focusTarget = direction
        ? main.querySelector(`.asm-product-carousel__arrow[data-asm-carousel-direction="${direction}"]`)
        : main.querySelector('.asm-page-choice__toggle');
      focusTarget?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name === 'AbortError' || request !== activeRequest) return;
      if (!pushHistory) {
        // A failed Back/Forward fetch must not leave the URL and product mismatched.
        window.location.replace(url);
        return;
      }
      feedback.textContent = 'Məhsul yüklənmədi. Yenidən seçin.';
    } finally {
      if (request === activeRequest) {
        activeRequest = null;
        product.removeAttribute('aria-busy');
        product.classList.remove('asm-product-choice-loading');
        buttons.forEach((button, index) => {
          button.disabled = previousDisabled[index];
          buttonStates.delete(button);
        });
      }
    }
  }

  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('.asm-page-choice__list a, .asm-product-carousel__arrow') : null;
    if (!link || !touchLayout.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || typeof HTMLUpdateUtility === 'undefined') return;
    event.preventDefault();
    if (url.pathname === location.pathname) return;
    loadProduct(url.href, true, Number(link.dataset.asmCarouselDirection) || 0);
  });

  window.addEventListener('popstate', () => {
    if (!touchLayout.matches || !location.pathname.includes('/products/')) return;
    const product = document.querySelector('main#MainContent product-info[data-product-handle]');
    if (!product) return;
    const handle = decodeURIComponent(location.pathname.split('/products/')[1].split('/')[0]);
    if (handle !== product.dataset.productHandle || activeRequest) loadProduct(location.href, false);
  });
})();
